import { StateCreator } from 'zustand';
import { CheckoutFragment } from '@/gql';
import { CheckoutSteps } from '@/constants/checkout';
import { ValueOf } from '@/lib/tsutils';

export interface CheckoutSlice {
  checkoutId?: string;
  setCheckoutId: (checkoutId: string) => void;
  checkoutRecord?: CheckoutFragment;
  setCheckoutRecord: (record?: CheckoutFragment) => void;
  checkoutValidated: boolean;
  setCheckoutValidated: (validated: boolean) => void;
  currentCheckoutStep: ValueOf<typeof CheckoutSteps>;
  setCheckoutStep: (step: ValueOf<typeof CheckoutSteps>) => void;
}

export const createCheckoutSlice: StateCreator<CheckoutSlice, [], [], CheckoutSlice> = (set) => ({
  checkoutId: undefined,
  setCheckoutId: (checkoutId) => set({ checkoutId }),
  checkoutRecord: undefined,
  setCheckoutRecord: (record) => {
    set({ checkoutRecord: record, checkoutId: record?.id || undefined });
  },
  checkoutValidated: false,
  setCheckoutValidated: (validated) => set({ checkoutValidated: validated }),
  currentCheckoutStep: CheckoutSteps.INIT,
  setCheckoutStep: (step) => {
    if (step < CheckoutSteps.INIT || step > CheckoutSteps.COMPLETE) {
      return;
    }
    set({ currentCheckoutStep: step });
  },
});
